import React from 'react';
import { array, func, string, bool, shape, number } from 'prop-types';
import { useTranslation } from 'react-i18next';
import useStyles from 'hooks/useStyles';

import Link from 'components/Link';
import ContentIntroCard from 'components/ContentIntroCard';

import { INSTRUCTOR_PROFILE } from 'constants/eventSection';
import { INSTRUCTOR } from 'constants/pageTypes';

import styles from './InstructorContentList.scss';
import useGetCurrentImageType from 'hooks/useGetCurrentImageType';

function InstructorContentList({
  title,
  moreTextLink,
  onMoreTextLinkClick,
  contentList,
  className,
  showMoreLink,
  instructor,
}) {
  useStyles(styles);
  const { t } = useTranslation(['instructorProfile']);
  const { imageType, setContainerRef } = useGetCurrentImageType();

  return (
    <div ref={setContainerRef} className={className}>
      <div className={styles.titleRow}>
        <h4>{title}</h4>

        {showMoreLink && (
          <Link
            to={moreTextLink}
            className={styles.viewAll}
            onClick={onMoreTextLinkClick}
          >
            {t('seeMoreCta')}
          </Link>
        )}
      </div>
      <ul className={styles.contentList}>
        {contentList.map((contentInfo, index) => (
          <li key={contentInfo.id}>
            <ContentIntroCard
              {...contentInfo}
              section={INSTRUCTOR_PROFILE}
              pageType={INSTRUCTOR}
              serialNumber={index + 1}
              instructor={instructor}
              pictureUrl={contentInfo?.picture[imageType]}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

InstructorContentList.propTypes = {
  moreTextLink: string.isRequired,
  onMoreTextLinkClick: func.isRequired,
  title: string.isRequired,
  contentList: array.isRequired,
  showMoreLink: bool.isRequired,
  className: string,
  instructor: shape({
    id: number,
    name: string,
  }),
};
InstructorContentList.defaultProps = {
  className: '',
  instructor: {},
};
export default InstructorContentList;
